import { TypeInitProps, TypeRequest } from '../../types';
import { encryptParams } from '../../utils/index';
import { WEB_URL } from '../../utils/urls';
export default class AccountAPI {
  private request: TypeRequest;
  constructor(props: TypeInitProps & { request: TypeRequest }) {
    const { request } = props;
    this.request = request;
  }
  /**
   * @return {Promise} request result
   */
  getAccountInfo = (params: { extra_params?: object } = {}) => {
    const { extra_params = {} } = params;
    return this.request({
      url: WEB_URL.ACCOUNT_INFO,
      method: 'GET',
      data: extra_params,
    });
  };
  /**
   * @param {string} password - password
   * @param {string} username - username
   * @return {Promise} set result
   */
  setAccount = (params: {
    password?: string;
    username?: string;
    extra_params?: object;
  }) => {
    const { password, username, extra_params = {} } = params || {};
    let data = encryptParams({ password, username, ...extra_params }, [
      'password',
      'username',
    ]);
    return this.request({
      url: WEB_URL.ACCOUNT_SET,
      method: 'POST',
      data,
    });
  };
  /**
   * @param {string} login_name - login name
   * @return {Promise} register result
   */
  registerLoginName = (params: {
    login_name: string;
    extra_params?: object;
  }) => {
    const { login_name, extra_params = {} } = params;
    return this.request({
      url: WEB_URL.ACCOUNT_REGISTER_LOGIN_NAME,
      method: 'POST',
      data: {
        login_name,
        ...extra_params,
      },
    });
  };
  /**
   * @param {number} platform_app_id
   * @param {string} next
   * @param {string} action
   * @return {Promise} request result
   */
  authConfig = (params: {
    platform_app_id: number;
    next: string;
    action: string;
    extra_params?: object;
  }) => {
    const { platform_app_id, next, action, extra_params = {} } = params;
    return this.request({
      url: WEB_URL.ACCOUNT_AUTH_CONFIG,
      method: 'POST',
      data: {
        platform_app_id,
        next,
        action,
        ...extra_params,
      },
    });
  };
  /**
   * @param {string} login_name - login name
   * @return {Promise} register result
   */
  updateLoginName = (params: { login_name: string; extra_params?: object }) => {
    const { login_name, extra_params = {} } = params;
    return this.request({
      url: WEB_URL.ACCOUNT_UPDATE_LOGIN_NAME,
      method: 'POST',
      data: {
        login_name,
        ...extra_params,
      },
    });
  };
}
